module.exports = __webpack_public_path__ + "img/cilinder-generator.98f00deb.jpg";